import React from "react";
import { Flex, HStack, Button, Text } from "@chakra-ui/react";

export default function PaginationBar({
  currentPage,
  totalPages,
  totalQuotes,
  visibleQuotes,
  itemsPerPage,
  onPageChange,
}) {
  return (
    <Flex justify="space-between" align="center" mt={4}>
      <Text>
        {visibleQuotes > 0
          ? `${(currentPage - 1) * itemsPerPage + 1}–${
              (currentPage - 1) * itemsPerPage + visibleQuotes
            } di ${totalQuotes}`
          : "Nessun risultato"}
      </Text>

      <HStack spacing={2}>
        <Button
          size="sm"
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          isDisabled={currentPage === 1}
        >
          ← Indietro
        </Button>
        <Text fontWeight="bold">
          {currentPage}/{totalPages}
        </Text>
        <Button
          size="sm"
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          isDisabled={currentPage === totalPages}
        >
          Avanti →
        </Button>
      </HStack>
    </Flex>
  );
}
